import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import AppRoutes from '../config/appRoutes';
import Authentication from "../views/Authentication/Authentication";
var AuthenticationLayout = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("main", { className: "main authentication" },
            React.createElement(Switch, null,
                React.createElement(Route, { path: AppRoutes.notAuth.path, key: AppRoutes.notAuth.key, component: Authentication, exact: true })))));
};
export default AuthenticationLayout;



//////////////////
// WEBPACK FOOTER
// ./src/layouts/authLayout.tsx
// module id = 552
// module chunks = 0